import React from 'react';
import { FormattedMessage } from 'react-intl';

const ErrorMessage = ({ message }) => {

    return (
        <div className="error margin-y-205 gutter10">
            <span className="error__border">
                <em className="excl">!</em>
                <span className="error__message">
                    <FormattedMessage 
                        id={message}
                    />
                </span>
            </span>
        </div>
    );
};

export default ErrorMessage;